import React, { useRef, useState } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import RankBrain2SidebarNavbar from 'RankBrain2SidebarNavbar';
import RankBrain2SidebarToggleButtonWithHover from 'RankBrain2SidebarToggleButton';
import useScrolledPast from 'hooks/useScrolledPast';
import NavbarHeader from './NavbarHeader';
import SectionItemTrigger from './SectionItemTrigger';

const navBarContainerStyle = {
  width: '100%',
  position: 'fixed',
  left: 0,
  top: 0,
  zIndex: 2,
};

const navBarStyle = {
  position: 'relative',
  zIndex: 10,
  paddingTop: 26,
  paddingBottom: 26,
};

const baseSidebarStyle = {
  position: 'fixed',
  right: 0,
  top: 100,
  height: '100%',
  flexDirection: 'column',
  paddingBottom: 70,
};

const RankBrain2StickyNavbar = ({ slug, documentName, dropDownSelection, sections }) => {
  const [isSideBarOpen, setIsSideBarOpen] = useState(false);
  const [activeSectionIdx, setActiveSectionIdx] = useState(0);
  const [activeSectionItemIdx, setActiveSectionItemIdx] = useState(0);
  const navbarTriggerRef = useRef(null);
  const isNavBarVisible = useScrolledPast(navbarTriggerRef);

  const toggleSideBar = () => {
    setIsSideBarOpen(state => !state);
  };

  const getSideBar = () => {
    const sidebarStyle = {
      ...baseSidebarStyle,
    };
    if (!isSideBarOpen) {
      sidebarStyle.display = 'none';
    }
    return (
      <div className="rank-brain-2-sticky-sidebar-navbar-container" style={sidebarStyle}>
        <RankBrain2SidebarNavbar
          enableSectionOpen
          toggleProps={{ toggleSideBar }}
          activeSectionIdx={activeSectionIdx}
          activeSectionItemIdx={activeSectionItemIdx}
          slug={slug}
          documentName={documentName}
          dropDownSelection={dropDownSelection}
          sections={sections}
        />
      </div>
    );
  };

  const getSideBarButton = () => {
    if (isSideBarOpen) {
      return (
        <RankBrain2SidebarToggleButtonWithHover
          className="rank-brain-2-sidebar-toggle-button-sticky-open"
          toggleSideBar={toggleSideBar}
          hoverImgSrc={`${window.formswiftUrl}/images/rank-brain-2/close-hover.png`}
          imgSrc={`${window.formswiftUrl}/images/rank-brain-2/close-default.png`}
        />
      );
    }

    return (
      <RankBrain2SidebarToggleButtonWithHover
        className="rank-brain-2-sidebar-toggle-button-sticky-close"
        toggleSideBar={toggleSideBar}
        hoverImgSrc={`${window.formswiftUrl}/images/rank-brain-2/icon-sections-hover-2x.png`}
        imgSrc={`${window.formswiftUrl}/images/rank-brain-2/icon-sections-2x.png`}
      />
    );
  };


  const navBarContainerStyleToUse = {
    ...navBarContainerStyle,
  };

  if (!isNavBarVisible) {
    navBarContainerStyleToUse.display = 'none';
  }

  let offset = 0;

  return (
    <React.Fragment>
      <div className="rank-brain-2-sticky-navbar-container" style={navBarContainerStyleToUse}>
        <div
          className="rank-brain-2-sticky-navbar"
          style={navBarStyle}
        >
          <NavbarHeader
            documentName={documentName}
            dropDownSelection={dropDownSelection}
            slug={slug}
          />
          {getSideBarButton()}
        </div>
        {getSideBar()}
      </div>
      <div ref={navbarTriggerRef} />
      { sections.map((section, sectionIdx) => {
        const sectionItemTriggers = (
          <React.Fragment key={section.idTarget}>
            {section.sectionItems.map((sectionItem, sectionItemIdx) =>
              <SectionItemTrigger
                key={sectionItem.idTarget}
                sectionItemOffset={offset}
                sectionIdx={sectionIdx}
                sectionItem={sectionItem}
                sectionItemIdx={sectionItemIdx}
                setActiveSectionIdx={setActiveSectionIdx}
                setActiveSectionItemIdx={setActiveSectionItemIdx}
              />,
            )}
          </React.Fragment>
        );
        offset += section.sectionItems.length;
        return sectionItemTriggers;
      })}
    </React.Fragment>
  );
};

RankBrain2StickyNavbar.init = (id, props) => {
  ReactDOM.render(
    <RankBrain2StickyNavbar {...props} />,
    document.getElementById(id),
  );
};

RankBrain2StickyNavbar.propTypes = {
  slug: PropTypes.string.isRequired,
  documentName: PropTypes.string.isRequired,
  dropDownSelection: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string,
  })).isRequired,
  sections: PropTypes.arrayOf(PropTypes.shape({
    idTarget: PropTypes.string,
    iconSrc: PropTypes.string,
    iconSrcHover: PropTypes.string,
    sectionItems: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string,
      idTarget: PropTypes.string,
    })),
  })).isRequired,
};

export default RankBrain2StickyNavbar;



// WEBPACK FOOTER //
// ./src-react/RankBrain2StickyNavbar/index.jsx